export function readMore() {
    const readMores =
        document.querySelectorAll<HTMLElement>("[data-read-more]");

    if (readMores.length > 0) {
        readMores.forEach((readMore) => {
            const dataRelation: string = readMore.getAttribute(
                "data-read-more",
            ) as string;
            const readMoreColor: string = readMore.getAttribute(
                "data-read-more-color",
            ) as string;
            if (readMore.innerHTML.length > Number(dataRelation)) {
                const showMoreLinkString: string =
                    '<div class="gradient"' +
                    `style="background: linear-gradient(to bottom, rgb(34 34 34 / 0%) 0%, ${readMoreColor} 50%);">` +
                    '<span class="show-more-link">mehr anzeigen<load-svg src="/media/icon/arrow-right-small.svg">' +
                    "<style>\n" +
                    "    svg  { height: 10px }\n" +
                    "    svg  { width: 24px }\n" +
                    "    svg  { margin-left: 8px }\n" +
                    "  </style></load-svg></span></div>";
                readMore.style.maxHeight = "250px";
                readMore.style.overflow = "hidden";
                readMore.insertAdjacentHTML("afterend", showMoreLinkString);
            }
        });

        const showMoreLink =
            document.querySelectorAll<HTMLElement>(".gradient");

        showMoreLink.forEach((readMoreButton) => {
            readMoreButton.addEventListener("click", function () {
                const containerToOpen: HTMLElement =
                    readMoreButton.previousSibling as HTMLElement;
                containerToOpen.style.maxHeight = "100%";
                containerToOpen.style.overflow = "inherit";
                readMoreButton.remove();
            });
        });
    }
}
